export default __webpack_public_path__ + "static/media/cancel-1.391b4f49.png";